import React from 'react';
import { Gift, CheckCircle } from 'lucide-react';
import { PriceDisplay } from '../ui/PriceDisplay';
export function Bonuses() {
  const bonuses = [{
    num: '1',
    title: 'Recetario de Snacks y Premios Saludables — "El Libro de las Delicias"',
    desc: '50 recetas de snacks caseros que tu mascota va a enloquecerle. Perfectos para el entrenamiento, para premios diarios, o simplemente para consentirlos con algo sano.',
    sub: 'Nada de galletitas con colorantes. Estas recetas son 100% naturales, rápidas y económicas.',
    valueType: 'b1' as const,
    image: 'https://cdn.magicpatterns.com/uploads/8NncRqdjXAjgrovoecjGaC/20260318_2303_Libro_de_Delicias_simple_compose_01km1xaqs0fyrbzkcm66z2ebx8_(1).webp'
  }, {
    num: '2',
    title: 'Guía de Primeros Auxilios Nutricionales — "¿Qué Hago Si...?"',
    desc: '¿Tu mascota comió algo que no debía? ¿Tiene diarrea de repente? ¿No come hace dos días? Esta guía te da los pasos exactos a seguir en cada emergencia nutricional común antes de llegar al veterinario.',
    sub: 'La tenés en el celular, disponible 24/7. Cuando la necesitás, la tenés.',
    valueType: 'b2' as const,
    image: 'https://cdn.magicpatterns.com/uploads/aQJsqTwQL4sh7rvhWpLE5u/20260318_1308_Image_Generation_simple_compose_01km0v8b0rex4at2e9fk2zp784_(1)_(1).webp'
  }, {
    num: '3',
    title: 'Acceso al Grupo Privado "Familia Alimenta Con Amor" — Comunidad de Por Vida',
    desc: 'Más de 2.000 dueños apasionados compartiendo fotos de sus mascotas transformadas, resolviendo dudas, intercambiando recetas y apoyándose mutuamente.',
    sub: 'Cuando tenés una duda a las 11 de la noche, ahí siempre hay alguien que ya pasó por lo mismo.',
    valueType: 'b3' as const,
    isYearly: true,
    image: 'https://cdn.magicpatterns.com/uploads/8qZ3y39LpvWnRFJU1LzGs3/20260318_2308_Image_Generation_simple_compose_01km1xm7amekt8zj474rdw6a1h_(1).webp'
  }];
  return <section className="py-10 px-4 bg-forest-green text-cream relative overflow-hidden" data-id="element-13">
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#D4A017 2px, transparent 2px)',
      backgroundSize: '40px 40px'
    }} data-id="element-14"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-15">
        <div className="text-center mb-6" data-id="element-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gold rounded-full mb-3 shadow-glow-lg border-4 border-white/10" data-id="element-17">
            <Gift className="w-8 h-8 text-forest-green" data-id="element-18" />
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-gold font-serif leading-tight drop-shadow-md" data-id="element-19">
            Si Pedís Hoy, Estos 3 Bonos Exclusivos Son Tuyos Gratis:
          </h2>
        </div>

        <div className="space-y-5" data-id="element-20">
          {bonuses.map((bono, idx) => <div key={idx} className="bg-white text-forest-green p-5 md:p-6 rounded-2xl shadow-2xl border-4 border-gold relative mt-2 transform transition-transform hover:-translate-y-1" data-id="element-21">
              <div className="absolute -top-5 -right-2 md:-right-4 bg-gold text-forest-green font-black px-6 py-2 rounded-xl shadow-lg text-lg md:text-xl border-2 border-white rotate-3" data-id="element-22">
                🎁 BONO #{bono.num}
              </div>

              <h3 className="text-2xl md:text-3xl font-black mb-3 pr-20 md:pr-32 text-balance leading-tight font-serif" data-id="element-23">
                {bono.title}
              </h3>

              {bono.image && <img src={bono.image} alt={bono.title} className="w-full max-w-sm mx-auto rounded-xl shadow-lg mb-3 border-2 border-gray-100" data-id="element-24" />}

              <p className="text-gray-700 text-lg md:text-xl mb-3 leading-relaxed font-medium" data-id="element-25">
                {bono.desc}
              </p>

              <div className="flex items-start gap-3 mb-4 bg-green-50/80 p-3 rounded-xl border border-green-200 shadow-inner" data-id="element-26">
                <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-27" />
                <p className="text-green-900 font-bold text-base md:text-lg leading-relaxed" data-id="element-28">
                  {bono.sub}
                </p>
              </div>

              <div className="border-t-2 border-dashed border-gray-300 pt-4 flex flex-col sm:flex-row items-center justify-between gap-3 bg-gray-50 -mx-5 md:-mx-6 -mb-5 md:-mb-6 p-5 md:p-6 rounded-b-xl" data-id="element-29">
                <div className="text-lg md:text-xl text-gray-500 font-bold" data-id="element-30">
                  Precio real:{' '}
                  <span className="line-through decoration-danger decoration-[3px] text-gray-400" data-id="element-31">
                    <PriceDisplay type={bono.valueType} showCurrencyCode data-id="element-32" />
                    {bono.isYearly ? '/año' : ''}
                  </span>
                </div>
                <div className="bg-danger text-white font-black px-6 py-3 rounded-xl text-lg md:text-xl uppercase tracking-widest shadow-[0_4px_15px_rgba(192,57,43,0.5)] border-2 border-danger/50 animate-pulse-glow" data-id="element-33">
                  → TUYO GRATIS {bono.isYearly ? 'DE POR VIDA' : ''}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}